import { EventTracker } from '@/utils/event_tracker'
import { CustomTraceProvider } from '@/utils/custom_trace'

export class PerformanceLogger {
  private lcpTraceNamePrefix = 'CUSTOM_TRACE:LCP:'
  private fcpTraceNamePrefix = 'CUSTOM_TRACE:FCP:'
  private performanceTraceTargets = [
    '/notice',
    '/events',
    '/gacha_odds',
    '/furniture_gacha_odds',
    '/mypage',
  ]

  public isLogTarget(pathname: string): boolean {
    return this.performanceTraceTargets.some((path) =>
      pathname.startsWith(path)
    )
  }

  // PerformanceObserverのfirst-contentful-paintイベントを記録する
  // https://developer.mozilla.org/en-US/docs/Web/API/PerformancePaintTiming
  public logFirstContentfulPaint(
    entry: PerformanceEntry,
    now: number,
    pathname: string
  ) {
    const duration = Math.round(entry.startTime)
    const startTime = now - duration
    const traceName = `${this.fcpTraceNamePrefix}PAGE`
    const attributes: { [key: string]: string } = {
      type: entry.entryType,
      pathname: pathname,
    }

    // firebase performance monitoringに出力
    CustomTraceProvider.record(traceName, startTime, duration, attributes)

    // firebase analyticsに出力
    EventTracker.default.trackPageFcp(duration, pathname)
  }

  // PerformanceObserverのlargest-contentful-paintイベントを記録する
  // https://developer.mozilla.org/en-US/docs/Web/API/LargestContentfulPaint
  public logLargestContentfulPaint(
    entry: PerformanceEntry,
    now: number,
    pathname: string
  ) {
    const lcpEntry = entry as PerformanceEntry & {
      url?: string
      element?: Element
    }
    const duration = Math.round(lcpEntry.startTime)
    const startTime = now - duration
    const traceName = lcpEntry.url
      ? `${this.lcpTraceNamePrefix}CONTENT` // 画像などのコンテンツの場合はURLが含まれる
      : `${this.lcpTraceNamePrefix}PAGE` // ページの場合はURLが含まれない

    // 画像の場合はURLとサイズを取得
    let contentUrl = ''
    let contentWidth = 0
    let contentHeight = 0
    if (lcpEntry.element && lcpEntry.element instanceof HTMLImageElement) {
      contentUrl = lcpEntry.url || ''
      contentWidth = lcpEntry.element.naturalWidth
      contentHeight = lcpEntry.element.naturalHeight
    }

    const attributes: { [key: string]: string } = {
      type: lcpEntry.entryType,
      pathname: pathname,
      url: contentUrl,
    }

    // firebase performance monitoringに出力
    CustomTraceProvider.record(traceName, startTime, duration, attributes)

    // firebase analyticsに出力
    EventTracker.default.trackPageLcp(
      duration,
      pathname,
      contentUrl,
      contentWidth,
      contentHeight
    )
  }
}
